<mat-form-field appearance="outline">
  <mat-label> Coordinates(Lat,Lng) </mat-label>

  <input matInput [formControl]="formCtrl" readonly [required]="required" />

  <mat-error *ngIf="formCtrl.hasError('invalidCharacters')">
    {{ hint }}
  </mat-error>

  <mat-error *ngIf="formCtrl.hasError('required')"> Coordinates are required </mat-error>

  <mat-icon class="input-suffix" matSuffix> location_on </mat-icon>

  <mat-hint *ngIf="hint"> {{ hint }} </mat-hint>
</mat-form-field>
